import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import el from 'vuetify/es5/locale/el'
import en from 'vuetify/es5/locale/en'

Vuetify.config.silent = import.meta.env.MODE === 'production' || false

Vue.use(Vuetify)

export default new Vuetify({
  rtl  : false,
  theme: {
    disable: false,
    dark   : false,
    default: 'light',
    options: {
      cspNonce        : undefined,
      minifyTheme     : undefined,
      themeCache      : undefined,
      customProperties: true,
      variations      : true
    },
    themes: {
      light: {
        anchor   : '#2196F3',
        primary  : '#1976D2',
        secondary: '#424242',
        accent   : '#82B1FF',
        error    : '#FF5252',
        info     : '#2196F3',
        success  : '#4CAF50',
        warning  : '#FB8C00'
      }
    }
  },
  lang: {
    locales: {
      el,
      en
    },
    current: import.meta.env.VITE_I18N_LOCALE
  },
  icons: {
    iconfont: 'md',
    values  : {}
  },
  breakpoint: {
    mobileBreakpoint: 1264,
    scrollBarWidth  : 16,
    thresholds      : {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920
    }
  }
})
